import { numberFilters } from '../../utils/number-filters';
import { safeDecodeURI } from '../../utils/safe-decode-uri';

export const PRICE_URL_TEXT = 'preco';

export interface PriceRangeProps {
  routeState: Record<string, string>;
  href: string;
}

const priceRangeFilter = (props: PriceRangeProps) => {
  const { routeState, href } = props;

  const numberFilter = numberFilters(href);

  const ranges = Object.values(routeState)[0].split(':');
  const range = !ranges[0] ? ranges[1] : ranges.join('-');

  if (href.includes(PRICE_URL_TEXT)) {
    let [origin, search = ''] = href.split('?');

    if (search.includes(PRICE_URL_TEXT)) {
      const searchParams = new URLSearchParams(search);

      searchParams.set(`filter[${PRICE_URL_TEXT}]`, range);
      search = safeDecodeURI(searchParams.toString());

      return [origin, search].join('?');
    }

    origin = origin
      .split('/')
      .map((item, idx, arr) => {
        if (idx === arr.length - 1) {
          return range;
        }

        return item;
      })
      .join('/');

    if (search) {
      return [origin, search].join('?');
    }

    return origin;
  }

  let newUrl = new URL(href);

  if (numberFilter === 0) {
    newUrl.pathname += `/${PRICE_URL_TEXT}/${range}`;
  } else if (numberFilter === 1) {
    newUrl.search = `?filter[${PRICE_URL_TEXT}]=${range}`;
  } else if (numberFilter > 1) {
    newUrl.search += `${
      newUrl.search ? '&' : ''
    }filter[${PRICE_URL_TEXT}]=${range}`;
  }

  return newUrl.toString();
};

export default priceRangeFilter;
